<template>
<header>パスワードの再設定<div class="h-left"><a @click="$router.go(-1)"><img src="~@/assets/images/icon02.svg"></a></div>
</header>
<div id="wrap">
    <div class="txt-area">
        <p>入力された携帯電話番号に、再設定用SMSを送信します。SMSのリンクからパスワードを再設定してください。</p>
    </div>
    <div class="cp_iptxt">
        <input type="text" pattern="[0-9]*" inputmode="numeric" placeholder="携帯電話番号" maxlength="11" v-model="phoneNumber" autocomplete="off">
        <i class="fas fa-mobile-alt fa-lg fa-fw" aria-hidden="true"></i>
    </div>
    <p class="login-4">SMSを受け取ることができる携帯電話番号を入力してください</p>

    <div :class="phoneNumber && phoneNumber.length === 11 ? 'btn1' : 'btn3'"><a @click="submit">送信</a></div>
    <div class="login-3">アカウントをお持ちでない場合<a @click="$router.push({name: 'register', query: {is_main: 1}})">登録はこちら</a></div>
</div>
<alertDialog :active="isAlert" @close="closeAlert()">
    <div>{{ alertMessage}}</div>
</alertDialog>
<div class="loading-screen" style="opacity: 0.6" v-if="isLoading">
    <div class="loader"></div>
</div>
</template>
<script>
import alertDialog from '@/views/components/alertDialog'
export default {
    data: () => ({
        phoneNumber: null,
        isAlert: false,
        alertMessage: null,
        isLoading: false
    }),
    components: {
        alertDialog
    },
    mounted() {
        window.scrollTo(0, 0)
    },
    methods: {
        submit() {
            this.isLoading = true
            this.$store.dispatch('login/resetPass', {
                phone_number: this.phoneNumber
            }).then(data=> {
                this.isLoading = false
            }).catch(err => {
                this.isAlert = true
                this.alertMessage = err.response.data.message
                this.isLoading = false
            })
        },
        closeAlert() {
            this.isAlert = false
        },
    }
}

</script>
<style scoped>

</style>
